import React, { FC, useContext } from "react";
import { Badge, Button, Card, Image } from "react-bootstrap";
import { ImageUploadProvider, ImageUploadProviderContext } from "../../../providers/ImageUploadProvider";
import ImageUploader from "../../../components/ImageUploader";
import clsx from "clsx";
import { useAuth } from "../../../hooks/useAuth";
import moment from "moment";
import { useIntl } from "react-intl";
import { LANG_COMMON_CHOOSE, LANG_COMMON_PERSONAL_INFO, LANG_COMMON_VIEW, LANG_PERSON_AGE, LANG_PERSON_EYES_COLOR, LANG_PERSON_HAIR_COLOR, LANG_PERSON_HAIR_TYPE, LANG_PERSON_HEIGHT, LANG_PERSON_RACE, LANG_PERSON_SKIN_COLOR } from "../../../lang";
import { OptionsContext } from "../../../providers/OptionsContextProvider";
import { PersonType } from "../../../types/PersonType";
import { useUtil } from "../../../hooks/useUtil";
import "./person-card.css";

interface Props {
    person: PersonType
    onSelect: (person: PersonType) => void
    onSelectMatching?: (person: PersonType) => void
}

const PersonCard: FC<Props> = ({ person, onSelect, onSelectMatching }) => {
    const intl = useIntl();
    const util = useUtil();

    return (
        <div className="paired-person-card">
            <ImageUploadProvider url={`/api/person/${person.id}/photo`} onChange={() => { }}>
                <ImageUploadProviderContext.Consumer>
                    {({ url, onChange, onRemove, loading, hasUploadError, hasDownloadError, download }) => (
                        <ImageUploader
                            hasUploadError={hasUploadError}
                            hasDownloadError={hasDownloadError}
                            download={download}
                            loading={loading}
                            height={304}
                            width={304}
                            url={url}
                            onChange={onChange}
                            onRemove={onRemove}
                            uploadUrl={`/api/person/${person.id}/photo`}
                            edit={false}
                            removeUrl={""}
                            photoLabel={`${person.name}`}
                            noGradient={true}
                            stared={false}
                            showCheckbox={false}
                        />
                    )}
                </ImageUploadProviderContext.Consumer>
            </ImageUploadProvider>
            <div className={'p-3'}>
                <ul>
                    <li>CPF: {person.cpf}</li>
                    {person.birth_date && (
                        <>
                            <li>Idade: {util.calculateAge(person.birth_date, 'YYYY-MM-DD')} anos</li>
                        </>
                    )}
                </ul>
                <div className="d-grid gap-2">
                    <Button
                        variant="primary"
                        className="btn-custom bg-custom-gradient btn-custom-small text-uppercase w-100"
                        onClick={() => onSelect(person)}
                    >{intl.formatMessage(LANG_COMMON_PERSONAL_INFO)}</Button>
                </div>
                <div className="d-grid gap-2 mt-2">
                    <Button
                        variant="primary"
                        className="btn-custom bg-custom-gradient btn-custom-small text-uppercase w-100"
                        onClick={() => onSelectMatching && onSelectMatching(person)}
                    >
                        <i className="icon icon-pairing"><svg version="1.1" id="Camada_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 20.19 19.64"><g><path className="st0" d="M17.13,5.35L15.08,7.4l-0.03,0.04c-0.03,0.03-0.04,0.04-0.06,0.08c-0.34,0.48-0.05,1.29,0.58,1.4 c0.28,0.05,0.57-0.05,0.78-0.25l3.58-3.58c0.17-0.18,0.27-0.43,0.26-0.68c-0.02-0.22-0.11-0.42-0.26-0.58l-3.58-3.58 c-0.03-0.03-0.04-0.04-0.07-0.07c-0.39-0.31-1.04-0.21-1.32,0.22c-0.21,0.34-0.16,0.81,0.13,1.11l2.05,2.05H0.89 C0.55,3.6,0.23,3.76,0.08,4.07c-0.18,0.36-0.07,0.84,0.25,1.09c0.16,0.13,0.36,0.17,0.56,0.2L17.13,5.35L17.13,5.35z M3.05,16.09 h16.24c0.33-0.04,0.66-0.2,0.81-0.51c0.08-0.16,0.07-0.21,0.09-0.39c-0.01-0.07-0.02-0.13-0.02-0.2c-0.04-0.13-0.09-0.25-0.17-0.36 c-0.13-0.16-0.31-0.27-0.5-0.31c-0.06-0.02-0.13-0.02-0.2-0.02H3.05l2.05-2.05c0,0,0.27-0.35,0.26-0.68c0-0.04,0-0.06-0.01-0.1 c-0.08-0.49-0.64-0.85-1.13-0.71c-0.1,0.03-0.19,0.07-0.27,0.13c-0.04,0.03-0.08,0.06-0.12,0.1l-3.58,3.58 c-0.03,0.03-0.04,0.04-0.07,0.08c-0.25,0.31-0.25,0.8,0,1.12c0.03,0.03,0.04,0.04,0.07,0.08l3.58,3.58 c0.03,0.03,0.04,0.04,0.08,0.07c0.47,0.38,1.33,0.12,1.44-0.55c0.05-0.28-0.05-0.57-0.25-0.78L3.05,16.09L3.05,16.09z"></path></g></svg></i> Matching
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default PersonCard;